module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/voicemod-lateral-ornament.437f261e.svg";